const MenuBtn = ({ icon, title, onClick, className = "" }) => {
    return (
        <button type="button" onClick={onClick} className={`row menubtn w-100 icon-btn ${className}`.trim()}>
            {icon ? <span className="menubtn__icon">{icon}</span> : null}
            <span className="menubtn__label">{title}</span>
        </button>
    )
}

const CreateLocation = ({ buttonText, showForm, setShowForm }) => {

    const buttonClick = () => {
  
        setShowForm(!showForm)
    }
    return (
        <button
            className="btn-blue"
            style={{ marginBottom: "15px", borderRadius: "0px" }}
            onClick={buttonClick}
        >
            {buttonText}
        </button>
    )
}


export {
    MenuBtn,
    CreateLocation
}
